import { ChangeEvent, useState } from 'react';
import { Avatar, Box, Button, Grid, Typography } from '@mui/material';
import { Icon } from 'ts-react-feather-icons';

import { acceptableImageType, imageTypeMessage } from 'utils/form';

import { useStyles } from './estate-task-icon.styles';

type Props = {
  defaultUrl?: string | null;
  onChange: (file: File) => void;
};

export const EstateTaskIcon = ({ onChange, defaultUrl }: Props) => {
  const classes = useStyles();
  const [iconErrorMessage, setIconErrorMessage] = useState<string>();
  const [icon, setIcon] = useState(defaultUrl);

  const handleIconChange = (e: ChangeEvent<HTMLInputElement>) => {
    setIconErrorMessage('');
    const { files } = e.target;
    if (files && files.length) {
      if (acceptableImageType(files[0].type)) {
        onChange(files && files[0]);
        setIcon(URL.createObjectURL(files && files[0]));
      } else {
        setIconErrorMessage(imageTypeMessage);
      }
    }
  };

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      className={classes.padding}
    >
      <Grid spacing={3} xs={12}>
        <Avatar
          alt="Estate task icon"
          src={icon || '/default_avatar.svg'}
          className={classes.icon}
        />
        <input id="icon" type="file" accept="image" onChange={handleIconChange} hidden />
      </Grid>
      <Grid spacing={3} xs={12}>
        <label htmlFor="icon">
          <Button component="span">
            <Icon name="edit" color="#44D2F2" />
            <Typography className={classes.buttonText} variant="caption">
              Edit Task Icon
            </Typography>
          </Button>
        </label>
      </Grid>
      <Box className={classes.inputError}>
        <Typography variant="caption">{iconErrorMessage}</Typography>
      </Box>
    </Grid>
  );
};
